import { getOr, set } from 'lodash/fp';

export default (pathFrom, pathTo = pathFrom, defaultValue) =>
  (acc, source) => {
    let value = getOr(defaultValue, pathFrom, source);

    if (typeof value === 'string') {
      value = Number(value);
    }

    return set(pathTo, value, acc);
  };
